<template>
  <van-popup v-model="showPage" position="bottom" class="progressTopInfo" @close="onClosed">
    <van-row class="popTitle">
      <van-col span="4" />
      <van-col span="16" class="center" :style="'color:'+GetDiveMainBack()">修改顾客出行时间</van-col>
      <van-col span="4" class="rigth"><i class="iconfont iconrigthjt" @click="showPage=false" /></van-col>
    </van-row>
    <div class="dataRect editRect">
      <van-row gutter="10" class="values">
        <van-col span="5"><span :style="'color:'+GetDiveMainBack()">新日期</span></van-col>
        <van-col span="19">
          <van-field v-model="data.date" style="padding:0" readonly placeholder="请选择新出行日期" @click="showBirthday=true" />
        </van-col>
      </van-row>
      <van-row gutter="10" class="values">
        <van-col span="5"><span :style="'color:'+GetDiveMainBack()">变更原因</span></van-col>
        <van-col span="19">
          <van-field v-model="data.about" style="padding:0" placeholder="请输入变更原因" type="textarea" rows="1" autosize maxlength="256" show-word-limit />
        </van-col>
      </van-row>

      <van-row gutter="10">
        <van-col span="12"><van-button :color="GetColorSecondary()" size="small" style="width:100%" @click="showPage=false">取消修改</van-button></van-col>
        <van-col span="12"><van-button :color="GetDiveMainBack()" size="small" style="width:100%" :loading="buttonLoading" @click="onChangeDate">确认修改</van-button></van-col>
      </van-row>
    </div>
    <dateSelect v-model="showBirthday" :max-date="maxDate" :min-date="minDate" @onChange="onBirthdayChange" />
  </van-popup>
</template>
<script>
import request from '@/utils/request'
import dateSelect from '@/components/dateSelect'
import { Button, Popup, Field, Dialog, RadioGroup, Radio, Checkbox } from 'vant'
import { GetEnumList, formatDate, GetEnumText, MyNotify, getScoreText, GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
// import { formatDate } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.name]: Dialog,
    [Checkbox.name]: Checkbox,
    dateSelect
  },
  props: {
    // eslint-disable-next-line
    value: Boolean,
    // eslint-disable-next-line
    studentId:undefined,
  },
  data() {
    return {
      showPage: false,
      buttonLoading: false,
      showBirthday: false,
      minDate: new Date(),
      maxDate: new Date(),
      data: {
        studentId: undefined,
        about: '',
        date: undefined
      }
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.showPage = true
        setTimeout(() => {
          this.maxDate = new Date(this.maxDate.setDate(this.maxDate.getDate() + 365))
          this.minDate = new Date(this.minDate.setDate(this.minDate.getDate() - 365))
          console.log('this.maxDate', this.maxDate)
        }, 1)
      } else {
        this.showPage = false
      }
    },
    studentId(newValue) {
      console.log('studentId', newValue)
      this.data.studentId = newValue
    }
  },
  created() {

  },
  methods: {
    GetEnumList,
    formatDate,
    GetEnumText,
    MyNotify,
    getScoreText,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetColorMainLine,
    onBirthdayChange(date) {
      this.data.date = date
    },
    onClosed() {
      console.log('onClosed')
      this.$emit('input', undefined)
    },
    onChangeDate() {
      if (!this.data.about || this.data.about === '') {
        MyNotify('info', '请输入变更原因', 2000)
        return
      }
      if (!this.data.date) {
        MyNotify('info', '请输入变更后日期', 2000)
        return
      }
      this.buttonLoading = true
      request({
        url: '/DiveTrip/updateStartDate',
        method: 'post',
        data: this.data
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '修改日期成功', 2000)
        this.$emit('reload')
        this.showPage = false
      })
    }
  }
}
</script>

<style scoped>
.progressTopInfo{
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
}
.progressTopInfo .dataRect
{
  padding: 0 0.5em;
  overflow: hidden;
  font-size: 0.8em;
  line-height: 1.5em;
}
.progressTopInfo .editRect
{
  padding-top: 0.5em;
  padding-bottom: 1em;
  line-height: 2.5em;
}
.progressTopInfo .popTitle
{
  padding: 0.5em 0.5em;
  border-bottom: 1px solid #f5f5f5;
}

</style>
